import React, { Component } from 'react';
import './securesubmissions.css';

/*
 * Read-only audit log of sensitive-data access. Lists every decrypted view and
 * every purge of a secure submission (who, role, which submission, when, IP).
 * Gated to Admin/Staff server-side, same as Secure Submissions.
 */
export class AuditLog extends Component {
    static displayName = AuditLog.name;

    constructor(props) {
        super(props);
        this.state = {
            logs: [],
            ready: false,
            authorized: true
        };
    }

    componentDidMount() {
        this.getComponentData();
    }

    async getComponentData() {
        const response = await fetch('SecureSubmission/GetAuditLogs', {
            method: 'GET',
            headers: { 'Accept': 'application/json' }
        });

        if (response.status === 401) {
            this.setState({ authorized: false, ready: true });
            return;
        }

        const data = await response.json();
        this.setState({ logs: data, ready: true });
    }

    formatDate(value) {
        if (value == null) return '';
        let d = new Date(value);
        return isNaN(d) ? '' : d.toLocaleString();
    }

    render() {
        if (!this.state.ready) {
            return <div className='secure-submissions-container'><p>Loading...</p></div>;
        }

        if (!this.state.authorized) {
            return (
                <div className='secure-submissions-container'>
                    <div className='page-title'><h1>Audit Log</h1></div>
                    <p role='alert'>You do not have permission to view the audit log. This area requires the Staff or Admin role.</p>
                </div>
            );
        }

        let rows = this.state.logs.map((l) => (
            <tr key={l.id}>
                <td>{this.formatDate(l.timestamp)}</td>
                <td>{l.action}</td>
                <td>{l.formName}</td>
                <td>#{l.submissionId}</td>
                <td>{l.userEmail || l.userId}</td>
                <td>{l.userRole}</td>
                <td>{l.ipAddress}</td>
            </tr>
        ));

        return (
            <div className='secure-submissions-container'>
                <div className='page-title'><h1>Sensitive Data Audit Log</h1></div>

                {this.state.logs.length === 0
                    ? <p>No access has been logged yet.</p>
                    : (
                        <table className='secure-submissions-table'>
                            <caption className='sr-only'>Audit log of sensitive data access</caption>
                            <thead>
                                <tr>
                                    <th scope='col'>When</th>
                                    <th scope='col'>Action</th>
                                    <th scope='col'>Form</th>
                                    <th scope='col'>Submission</th>
                                    <th scope='col'>User</th>
                                    <th scope='col'>Role</th>
                                    <th scope='col'>IP</th>
                                </tr>
                            </thead>
                            <tbody>{rows}</tbody>
                        </table>
                    )}
            </div>
        );
    }
}

export default AuditLog;
